'use client'

import ErrorBoundary from '../ErrorBoundary'

interface Props {
  children: React.ReactNode
}

// Thin wrapper to allow ErrorBoundary (client component) to wrap
// server-rendered children passed as props from a Server Component layout.
export default function PageErrorBoundary({ children }: Props) {
  return <ErrorBoundary>{children}</ErrorBoundary>
}
